export const interpretationData = [
  { sqft: 220, price: 118247.0, pool: 0 },
  { sqft: 180, price: 106481.0, pool: 0 },
  { sqft: 230, price: 64301.0, pool: 0 },
  { sqft: 640, price: 541466.0, pool: 0 },
  { sqft: 125, price: 41373.0, pool: 0 },
  { sqft: 410, price: 194233.0, pool: 0 },
  { sqft: 140, price: 94561.0, pool: 0 },
  { sqft: 180, price: 74377.0, pool: 0 },
  { sqft: 480, price: 211827.0, pool: 0 },
  { sqft: 245, price: 113594.0, pool: 0 },
  { sqft: 500, price: 341359.0, pool: 0 },
  { sqft: 510, price: 538919.704520013, pool: 1 },
  { sqft: 550, price: 390992.704520013, pool: 1 },
  { sqft: 750, price: 381798.704520013, pool: 1 },
  { sqft: 630, price: 486506.704520013, pool: 1 },
  { sqft: 680, price: 404757.704520013, pool: 1 },
  { sqft: 300, price: 236704.704520013, pool: 1 },
  { sqft: 654, price: 565233.704520013, pool: 1 },
  { sqft: 385, price: 245375.704520013, pool: 1 },
  { sqft: 730, price: 496553.704520013, pool: 1 },
  { sqft: 685, price: 378339.704520013, pool: 1 },
  { sqft: 653, price: 434042.704520013, pool: 1 },
];

export const scatterData = [
  {
    sqft: 0.2198239457,
    price: 1.5490632908,
    regressionLine: 0.78732,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 2.78831,
  },
  {
    sqft: 0.2677097574,
    price: -1.3889258939,
    regressionLine: 0.84024,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 2.79059,
  },
  {
    sqft: 0.6895357881,
    price: 3.9290644038,
    regressionLine: 1.30635,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 2.82993,
  },
  {
    sqft: 0.9845111983,
    price: 3.6718356356,
    regressionLine: 1.6323,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 2.87804,
  },
  {
    sqft: 1.6097653931,
    price: 2.1925685344,
    regressionLine: 2.3232,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.03607,
  },
  {
    sqft: 1.7616339283,
    price: 2.5072616943,
    regressionLine: 2.49102,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.08596,
  },
  {
    sqft: 2.3362605495,
    price: 1.3723238485,
    regressionLine: 3.12598,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.31537,
  },
  {
    sqft: 2.3588537021,
    price: 5.5394845731,
    regressionLine: 3.15094,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.32571,
  },
  {
    sqft: 2.5351338676,
    price: 3.8516873107,
    regressionLine: 3.34573,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.40976,
  },
  {
    sqft: 2.7059730609,
    price: -0.7492923843,
    regressionLine: 3.53451,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.497,
  },
  {
    sqft: 3.0631688198,
    price: 2.215262608,
    regressionLine: 3.92921,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.69777,
  },
  {
    sqft: 3.4310968577,
    price: 3.9126203584,
    regressionLine: 4.33577,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.93056,
  },
  {
    sqft: 3.5012369679,
    price: 5.2159503471,
    regressionLine: 4.41327,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 3.97793,
  },
  {
    sqft: 3.8327174076,
    price: 1.6443758587,
    regressionLine: 4.77956,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 4.21479,
  },
  {
    sqft: 4.348368482,
    price: 11.0868237341,
    regressionLine: 5.34935,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 4.62579,
  },
  {
    sqft: 4.7994541469,
    price: 6.1805450928,
    regressionLine: 5.8478,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 5.02782,
  },
  {
    sqft: 5.0619331287,
    price: 5.6297504409,
    regressionLine: 6.13784,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 5.28,
  },
  {
    sqft: 5.3713926965,
    price: 6.6259486869,
    regressionLine: 6.47979,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 5.59457,
  },
  {
    sqft: 5.4938852305,
    price: 6.1158880587,
    regressionLine: 6.61515,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 5.72424,
  },
  {
    sqft: 5.7938827736,
    price: 8.6797800616,
    regressionLine: 6.94664,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 6.05415,
  },
  {
    sqft: 5.8030220746,
    price: 7.1960080792,
    regressionLine: 6.95674,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 6.06448,
  },
  {
    sqft: 5.9196424695,
    price: 4.8768154365,
    regressionLine: 7.08561,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 6.19767,
  },
  {
    sqft: 6.0740579089,
    price: 7.0771038306,
    regressionLine: 7.25624,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 6.37811,
  },
  {
    sqft: 6.6570376728,
    price: 7.8352473782,
    regressionLine: 7.90043,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 7.10121,
  },
  {
    sqft: 6.8593690037,
    price: 8.0877677537,
    regressionLine: 8.124,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 7.36766,
  },
  {
    sqft: 7.0697657374,
    price: 7.4470025004,
    regressionLine: 8.35649,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 7.65318,
  },
  {
    sqft: 7.1427346843,
    price: 10.4932721567,
    regressionLine: 8.43712,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 7.75422,
  },
  {
    sqft: 7.855453658,
    price: 7.5201499552,
    regressionLine: 9.22467,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 8.79567,
  },
  {
    sqft: 7.9251166805,
    price: 6.9953521191,
    regressionLine: 9.30165,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 8.90278,
  },
  {
    sqft: 8.3155091659,
    price: 11.5928336964,
    regressionLine: 9.73303,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 9.52049,
  },
  {
    sqft: 8.3451533591,
    price: 8.3910457396,
    regressionLine: 9.76579,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 9.56861,
  },
  {
    sqft: 8.5476047562,
    price: 9.5000483662,
    regressionLine: 9.9895,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 9.90181,
  },
  {
    sqft: 8.6692043516,
    price: 9.5665805935,
    regressionLine: 10.12387,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 10.10578,
  },
  {
    sqft: 9.1817322968,
    price: 8.6891061946,
    regressionLine: 10.69021,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 10.99715,
  },
  {
    sqft: 9.2432138138,
    price: 11.1114771209,
    regressionLine: 10.75815,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 11.10752,
  },
  {
    sqft: 9.3767608398,
    price: 13.3097537552,
    regressionLine: 10.90571,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 11.34978,
  },
  {
    sqft: 9.6877914181,
    price: 12.81167534,
    regressionLine: 11.2494,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 11.92749,
  },
  {
    sqft: 9.8426447595,
    price: 15.6480938582,
    regressionLine: 11.42051,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 12.22215,
  },
  {
    sqft: 10.1878769987,
    price: 7.4272591115,
    regressionLine: 11.802,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 12.89588,
  },
  {
    sqft: 10.6866405845,
    price: 13.4476262457,
    regressionLine: 12.35313,
    regressionLineFlat: 4.0,
    regressionLineSqrt: 13.91024,
  },
];

export const mseData = [
  {
    sqft: 1.0,
    price: 2.0,
    sqft1: 1.0,
    price1: 2.0,
    sqft0: 0.964,
    price0: 1.716,
    sqft2: 1.13,
    price2: 1.529,
    sqft3: 1.077,
    price3: 1.322,
    sqft4: 0.074,
    price4: 3.524,
    sqft5: -0.015,
    price5: 6.659,
    sqft6: 0.222,
    price6: 4.32,
    sqft7: 0.885,
    price7: 0.952,
    sqft8: 0.24,
    price8: 2.776,
    sqft9: -0.878,
    price9: -0.594,
    sqft110: -0.152,
    price10: -3.306,
  },
  {
    sqft: 2.0,
    price: 3.0,
    sqft1: 2.0,
    price1: 3.0,
    sqft0: 2.014,
    price0: 2.671,
    sqft2: 1.683,
    price2: 4.65,
    sqft3: 2.438,
    price3: 1.967,
    sqft4: 1.46,
    price4: 3.417,
    sqft5: 1.936,
    price5: -0.344,
    sqft6: 2.445,
    price6: 9.914,
    sqft7: 1.824,
    price7: -2.705,
    sqft8: -0.102,
    price8: -2.522,
    sqft9: 2.634,
    price9: 1.112,
    sqft110: 1.267,
    price10: -1.052,
  },
  {
    sqft: 3.0,
    price: 4.0,
    sqft1: 3.0,
    price1: 4.0,
    sqft0: 3.156,
    price0: 3.284,
    sqft2: 3.06,
    price2: 4.244,
    sqft3: 2.223,
    price3: 3.792,
    sqft4: 3.039,
    price4: 1.397,
    sqft5: 1.869,
    price5: 8.687,
    sqft6: 3.827,
    price6: 2.442,
    sqft7: 1.521,
    price7: 0.306,
    sqft8: 2.19,
    price8: 0.801,
    sqft9: 3.473,
    price9: 3.667,
    sqft110: 4.455,
    price10: 16.832,
  },
  {
    sqft: 4.0,
    price: 5.0,
    sqft1: 4.0,
    price1: 5.0,
    sqft0: 3.83,
    price0: 5.42,
    sqft2: 3.799,
    price2: 5.571,
    sqft3: 3.763,
    price3: 4.109,
    sqft4: 3.323,
    price4: 3.156,
    sqft5: 4.164,
    price5: -0.635,
    sqft6: 3.616,
    price6: 7.321,
    sqft7: 3.305,
    price7: 4.703,
    sqft8: 3.992,
    price8: 9.478,
    sqft9: 2.198,
    price9: 0.128,
    sqft110: 2.448,
    price10: 5.197,
  },
  {
    sqft: 5.0,
    price: 6.0,
    sqft1: 5.0,
    price1: 6.0,
    sqft0: 5.012,
    price0: 5.686,
    sqft2: 5.004,
    price2: 7.095,
    sqft3: 5.374,
    price3: 7.538,
    sqft4: 5.313,
    price4: 3.967,
    sqft5: 5.162,
    price5: 4.656,
    sqft6: 4.801,
    price6: 9.402,
    sqft7: 6.337,
    price7: 3.237,
    sqft8: 3.296,
    price8: 0.086,
    sqft9: 5.711,
    price9: 4.268,
    sqft110: 2.518,
    price10: 2.206,
  },
  {
    sqft: 6.0,
    price: 7.0,
    sqft1: 6.0,
    price1: 7.0,
    sqft0: 5.994,
    price0: 6.938,
    sqft2: 6.099,
    price2: 6.599,
    sqft3: 6.898,
    price3: 3.521,
    sqft4: 6.367,
    price4: 5.809,
    sqft5: 5.762,
    price5: 10.85,
    sqft6: 4.787,
    price6: 6.472,
    sqft7: 7.957,
    price7: 6.367,
    sqft8: 6.581,
    price8: 11.441,
    sqft9: 4.659,
    price9: 3.875,
    sqft110: 7.633,
    price10: 8.227,
  },
  {
    sqft: 7.0,
    price: 8.0,
    sqft1: 7.0,
    price1: 8.0,
    sqft0: 6.955,
    price0: 7.332,
    sqft2: 7.32,
    price2: 7.113,
    sqft3: 6.797,
    price3: 10.926,
    sqft4: 6.265,
    price4: 7.158,
    sqft5: 6.999,
    price5: 8.726,
    sqft6: 6.796,
    price6: 11.038,
    sqft7: 4.715,
    price7: 7.107,
    sqft8: 6.031,
    price8: 5.869,
    sqft9: 5.611,
    price9: 5.518,
    sqft110: 7.922,
    price10: 14.564,
  },
  {
    sqft: 8.0,
    price: 9.0,
    sqft1: 8.0,
    price1: 9.0,
    sqft0: 7.864,
    price0: 8.433,
    sqft2: 8.165,
    price2: 8.738,
    sqft3: 8.282,
    price3: 7.218,
    sqft4: 7.162,
    price4: 8.187,
    sqft5: 8.214,
    price5: 10.975,
    sqft6: 8.709,
    price6: 12.377,
    sqft7: 8.67,
    price7: 7.299,
    sqft8: 6.519,
    price8: 5.653,
    sqft9: 9.994,
    price9: 13.515,
    sqft110: 8.474,
    price10: 10.576,
  },
  {
    sqft: 9.0,
    price: 10.0,
    sqft1: 9.0,
    price1: 10.0,
    sqft0: 8.956,
    price0: 9.612,
    sqft2: 8.886,
    price2: 9.047,
    sqft3: 8.194,
    price3: 13.048,
    sqft4: 9.292,
    price4: 8.243,
    sqft5: 9.561,
    price5: 12.499,
    sqft6: 8.53,
    price6: 12.323,
    sqft7: 10.528,
    price7: 8.662,
    sqft8: 8.477,
    price8: 16.863,
    sqft9: 7.737,
    price9: 10.652,
    sqft110: 9.001,
    price10: 13.155,
  },
  {
    sqft: 10.0,
    price: 11.0,
    sqft1: 10.0,
    price1: 11.0,
    sqft0: 10.324,
    price0: 10.952,
    sqft2: 10.366,
    price2: 9.033,
    sqft3: 9.885,
    price3: 14.104,
    sqft4: 9.661,
    price4: 16.644,
    sqft5: 9.774,
    price5: 13.031,
    sqft6: 9.801,
    price6: 4.651,
    sqft7: 8.522,
    price7: 10.803,
    sqft8: 11.267,
    price8: 20.49,
    sqft9: 7.531,
    price9: 10.637,
    sqft110: 8.619,
    price10: 11.324,
  },
];
